<template>
  <div class="position-absolute" style="margin: 10px; top: 0; right: 0; z-index: 999">
    <v-tooltip :text="$t('fullscreen')" location="start">
      <template #activator="{ props: tooltipProps }">
        <v-btn
          v-if="fullscreenCapable"
          v-bind="tooltipProps"
          color="surface"
          rounded="sm"
          density="compact"
          icon="fullscreen"
          :aria-label="$t('fullscreen')"
          style="width: 32px; min-height: 32px"
          @click="() => toggleFullscreen()"
        />
      </template>
    </v-tooltip>
  </div>
</template>

<script setup lang="ts">
const { element } = defineProps<{
  element: HTMLElement | null
}>()

const fullscreenCapable = computed(() => typeof document !== "undefined" && document.fullscreenEnabled && element)

const toggleFullscreen = async () => {
  if (!fullscreenCapable.value || !element) {
    return
  }

  if (typeof document !== "undefined" && document.fullscreenElement === element) {
    await document.exitFullscreen()
  } else {
    await element.requestFullscreen()
  }
}
</script>
